import "./es.object.assign-7e79fd7b.js";
import l from "styled-components";
import "./es.array.filter-4e9c9996.js";
import "./es.array.concat-d1c9b847.js";
import "./es.object.from-entries-0d7a0e54.js";
import "./es.array.map-d821aaf5.js";
import "./es.object.entries-d2a19275.js";
import "./es.object.to-string-f55666a8.js";
import "./es.string.replace-f4cc3aea.js";
import "./es.array.is-array-7a29277f.js";
import "react";
import "./web.dom-collections.for-each-3020ed11.js";
import { g as t } from "./getMetrics-953aa4f8.js";
import { c as u } from "./childrenCountCheck-bbe924c6.js";
import { jsxs as a, Fragment as p, jsx as m } from "react/jsx-runtime";
import "./export-cdcbfb2b.js";
import "./object-keys-719a5561.js";
import "./array-iteration-759bfbfa.js";
import "./create-property-f9780ed1.js";
import "./object-create-9b6715a2.js";
import "./html-32ef1b46.js";
import "./correct-is-regexp-logic-4465cd47.js";
import "./is-regexp-4c49b1c2.js";
import "./to-string-92a62764.js";
import "./classof-21a3574e.js";
import "./iterate-13ada9e5.js";
import "./object-to-array-0474b7e7.js";
import "./object-set-prototype-of-7d7e5736.js";
import "./function-uncurry-this-clause-99074d1c.js";
import "./function-apply-4756dee6.js";
import "./array-method-is-strict-e5a3c878.js";
var d = 4, c = /* @__PURE__ */ l.div.withConfig({
  displayName: "raisedSurface__Wrapper",
  componentId: "sc-7x5amd-0"
})(["display:", ";flex-direction:", ";gap:", ";height:", ";width:", ";"], function(e) {
  var r;
  return e == null || (r = e.theme) == null || (r = r.components) == null || (r = r.raisedSurface) == null ? void 0 : r.Wrapper.display;
}, function(e) {
  var r;
  return e == null || (r = e.theme) == null || (r = r.components) == null || (r = r.raisedSurface) == null ? void 0 : r.Wrapper.flexDirection;
}, function(e) {
  var r;
  return e == null || (r = e.theme) == null || (r = r.components) == null || (r = r.raisedSurface) == null ? void 0 : r.Wrapper.gap;
}, function(e) {
  var r;
  return e == null || (r = e.theme) == null || (r = r.components) == null || (r = r.raisedSurface) == null ? void 0 : r.Wrapper.height;
}, function(e) {
  var r;
  return e == null || (r = e.theme) == null || (r = r.components) == null || (r = r.raisedSurface) == null ? void 0 : r.Wrapper.width;
}), s = /* @__PURE__ */ l.div.withConfig({
  displayName: "raisedSurface__ChildWrapper",
  componentId: "sc-7x5amd-1"
})(["border-radius:", ";box-shadow:", ";width:", ";box-sizing:", ";border:", ";background-color:", ";box-sizing:", ";"], function(e) {
  var r;
  return e == null || (r = e.theme) == null || (r = r.components) == null || (r = r.raisedSurface) == null || (r = r.ChildWrapper) == null ? void 0 : r.borderRadius;
}, function(e) {
  var r;
  return e == null || (r = e.theme) == null || (r = r.components) == null || (r = r.raisedSurface) == null || (r = r.ChildWrapper) == null ? void 0 : r.boxShadow;
}, function(e) {
  var r;
  return e == null || (r = e.theme) == null || (r = r.components) == null || (r = r.raisedSurface) == null || (r = r.ChildWrapper) == null ? void 0 : r.width;
}, function(e) {
  var r;
  return e == null || (r = e.theme) == null || (r = r.components) == null || (r = r.raisedSurface) == null || (r = r.ChildWrapper) == null ? void 0 : r.boxSizing;
}, function(e) {
  var r;
  return e == null || (r = e.theme) == null || (r = r.components) == null || (r = r.raisedSurface) == null || (r = r.ChildWrapper) == null ? void 0 : r.border;
}, function(e) {
  var r;
  return e == null || (r = e.theme) == null || (r = r.components) == null || (r = r.raisedSurface) == null || (r = r.ChildWrapper) == null ? void 0 : r.backgroundColor;
}, function(e) {
  var r;
  return e == null || (r = e.theme) == null || (r = r.components) == null || (r = r.raisedSurface) == null || (r = r.ChildWrapper) == null ? void 0 : r.boxSizing;
}), h = function(r) {
  var n = r.children, i = r.className, o = t({
    label: "RaisedSurface"
  });
  return /* @__PURE__ */ a(p, {
    children: [u({
      children: n,
      componentName: "Raised Surface",
      maxChildren: d
    }), /* @__PURE__ */ m(c, Object.assign({
      className: i
    }, o, {
      children: n
    }))]
  });
};
h.Container = s;
export {
  h as RaisedSurface
};
